<template>
	<div class="container">
		<div class="content" v-html="content">
			
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {config, post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'rank',
		components: {},
		data(){
			return {
				content: ''
			}
		},
		created(){
			this.getDataPage()
		},
		methods: {
			//获取用户榜单
			async getDataPage(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/page/getPage', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					this.content = res.data.entity.content
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.content{
		width: 1180px;
		margin: 20px auto;
		background:#fff;
		border-radius: 10px;
		padding: 10px 20px 30px;
		box-sizing: border-box;
	}
</style>
